var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-scrollbar',{staticClass:"comp-sideBar"},[_c('el-menu',{attrs:{"background-color":"#4E5A56","text-color":"#ffffff","active-text-color":"#23926E","default-active":_vm.activePage}},_vm._l((_vm.routes),function(route,index){return _c('side-bar-item',{key:route.path + index + new Date().getTime(),attrs:{"item":route}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }